import "./App.css";
import { Routes, Route, Navigate, HashRouter,  } from "react-router-dom";

import React, { JSX, useEffect, useState } from "react";
import Login from "./components/login.component";

import Dashboard from "./components/dashboard/dashboard.component";
import { useSelector } from "react-redux";
import { UserState } from "./state/slice";
import NotFoundPage from "./components/notfound-component";
import { persistor } from "./state/store";
import UserEntry from "./components/user/user-entry.component";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const userData = useSelector((state: UserState) => state.user);
  const [rehydrated, setRehydrated] = useState(false);

  useEffect(() => {
    const checkPersist = async () => {
      await persistor.persist(); // Wait for persist to complete
      setRehydrated(true);
    };
    checkPersist();
  }, []);

  if (!rehydrated) {
    return null; // Prevents redirecting too soon
  }
  if (userData && "email" in userData) {
    return children;
  } else {
    console.log("navigate to login");
    return <Navigate to="/" replace />;
  }
};

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const allowedUsers = process.env.REACT_APP_ADMINS?.split(",") || [];

  const userData = useSelector((state: UserState) => state.user);

  const isAllowed = allowedUsers.includes(userData["email"]);
  console.log("isAllowed", isAllowed, userData["email"], process.env.REACT_APP_ADMINS);

  return isAllowed ? children : <Navigate to="/404" replace />;
};

//process.env.PUBLIC_URL is referring to homepage attribute on package.json file

const App = () => {
  return (
    <div className="App">
      <HashRouter basename="/">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<NotFoundPage />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/user"
            element={
              <ProtectedRoute>
                <UserEntry />
              </ProtectedRoute>
            }
          />
        </Routes>
      </HashRouter>
    </div>
  );
};

export default App;
